import React, { useEffect, useState } from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { baseTheme } from '../../../theme';
import BackupIcon from '@material-ui/icons/Backup';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  previewImage: {
    width: '100px',
    paddingRight: theme.spacing(1),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50px',
    width: '100px',
    paddingRight: theme.spacing(1),
  },
}));

export default function PostListItemHighlightImage(props: { image: string | undefined }) {
  const [imageError, setImageError] = useState<boolean>(false);
  const [displayImage, setDisplayImage] = useState<string>('');
  const classes = useStyles(baseTheme);

  useEffect(() => {
    setImageError(false);
    setDisplayImage(props.image || '');
  }, [props.image]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (imageError && props.image) {
      const imgChecker = new Image();
      imgChecker.onload = () => {
        setImageError(false);
      };
      imgChecker.onerror = () => {
        timeoutId = setTimeout(() => {
          const buster = `${props.image}&t=${Date.now()}`;
          setDisplayImage(buster);
          imgChecker.src = buster;
        }, 1500);
      };
      const initialBuster = `${props.image}&t=${Date.now()}`;
      setDisplayImage(initialBuster);
      imgChecker.src = initialBuster;
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [imageError, props.image]);

  const handleImageError = (e: any) => {
    setImageError(true);
  };
  return (
    <>
      {displayImage ? (
        <>
          {imageError ? (
            <div className={classes.loadingContainer}>
              <CircularProgress size={24} />
            </div>
              ) : (

              <img
                  className={classes.previewImage}
                  src={displayImage}
                  alt="preview"
                  onError={handleImageError}
              />
            )}
        </>
      ) : (
          <div className={classes.previewImage}>&nbsp;</div>
        )}
    </>
  );
}
